import * as ft from 'focus-trap'
import NavigationBar from '@vo/js/components/navigation-bar/NavigationBar'

const mobileNavToggle = () => {
    const openButton = document.querySelector('#mobile-nav-toggle')
    const closeButton = document.querySelector('#mobile-nav-close')
    const nav = document.querySelector('#mobile-nav')

    if (!openButton || !closeButton || !nav) return

    const focusTrap = ft.createFocusTrap(nav, {
        fallbackFocus: closeButton,
        escapeDeactivates: false
    })

    const isOpen = () => !nav.hasAttribute('hidden')

    const open = () => {
        if (isOpen()) return

        nav.removeAttribute('hidden')
        document.body.classList.add('overflow-hidden')
        mobileNavHeight()
        focusTrap.activate()
        closeButton.focus()
    }

    const close = () => {
        if (!isOpen()) return

        nav.setAttribute('hidden', '')
        document.body.classList.remove('overflow-hidden')
        focusTrap.deactivate()
        openButton.focus()
    }

    openButton.addEventListener('click', open)
    closeButton.addEventListener('click', close)
    nav.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close()
    })
}

const mobileNavHeight = () => {
    const nav = document.querySelector('#mobile-nav')

    if (!nav) return

    // Set offset top
    nav.style.top = getHeaderHeight() + 'px'

    // Set nav height
    nav.style.height = 'calc(100vh - ' + getHeaderHeight() + 'px)'
}

const getControlledPanel = (toggle) => {
    const controlsId = toggle.getAttribute('data-controls')

    return controlsId ? document.getElementById(controlsId) : null
}

const focusAfterActivation = (element) => {
    if (!element) return

    // Defer past the activating click/key event so the browser does not
    // return focus to the trigger (WCAG 2.4.3 — move focus into the submenu).
    window.setTimeout(() => {
        element.focus({ preventScroll: true })
    }, 0)
}

const mobileNavSubsToggle = () => {
    document.querySelectorAll('[data-module="mobile-nav-subs-toggle"]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const controlledElement = getControlledPanel(toggle)

            if (!controlledElement) return

            const isHidden = controlledElement.hasAttribute('hidden')
            const backButton = controlledElement.querySelector('[data-module="mobile-nav-subs-back"]')

            if (isHidden) {
                // Open only on activation (click / Enter / Space) — never on focus
                controlledElement.removeAttribute('hidden')
                controlledElement.removeAttribute('inert')
                updateMobileNavHeight(controlledElement)
                focusAfterActivation(backButton)
            } else {
                controlledElement.setAttribute('hidden', '')
                controlledElement.setAttribute('inert', '')
                updateMobileNavHeight()
                focusAfterActivation(toggle)
            }
        })
    })

    document.querySelectorAll('[data-module="mobile-nav-subs-back"]').forEach((back) => {
        back.addEventListener('click', () => {
            const panel = back.closest('nav[id^="subs-"]')

            if (!panel) return

            const parentToggle = document.querySelector(
                `[data-module="mobile-nav-subs-toggle"][data-controls="${panel.id}"]`
            )

            panel.setAttribute('hidden', '')
            panel.setAttribute('inert', '')
            updateMobileNavHeight()
            focusAfterActivation(parentToggle)
        })
    })
}

function getHeaderHeight () {
    const header = document.querySelector('#site-header')
    const adminBar = document.querySelector('#admin-bar')

    if (!header) return

    let offsetTop = header.offsetHeight

    if (adminBar) {
        offsetTop = offsetTop + adminBar.offsetHeight
    }

    return offsetTop
}

function updateMobileNavHeight (targetNav) {
    const baseHeight = window.innerHeight - getHeaderHeight()
    const nav = document.querySelector('#mobile-nav')
    const navInner = document.querySelector('#mobile-nav-inner')

    if (targetNav) {
        const targetHeight = targetNav.querySelector('ul').scrollHeight
        navInner.style.height = (targetHeight > baseHeight ? targetHeight : baseHeight) + 'px'
        nav.style.overflowY = 'hidden'
    } else {
        navInner.style.height = 'auto'
        nav.style.overflowY = 'auto'
    }
}

export default (function () {
    mobileNavToggle()
    mobileNavHeight()
    mobileNavSubsToggle()

    new NavigationBar(document.querySelector('#desktop-nav'))
})
